// libraries
import styled from 'styled-components';

export const StyledPhotoMapPreview = styled.div`
  margin-top: 12px;
  height: 220px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--color-pale-gray);

  .photo-map-preview-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--color-text-gray);
    font-size: 13px;
    background: var(--color-off-white);
  }
`;
